import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';

import { schedulerShowPopupState, schedulerTypeState } from './Scheduler.states';

export const useSchedulerPopup = () => {
    const [isOpen, setIsOpen] = useAtom(schedulerShowPopupState);

    const handleOpenPopup = useCallback(() => {
        setIsOpen(true);
    }, [setIsOpen]);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);

    return useMemo(
        () => ({
            isOpen,
            handleOpenPopup,
            handleClose,
        }),
        [isOpen, handleOpenPopup, handleClose]
    );
};

export const useSchedulerType = () => {
    const [schedulerType, setSchedulerType] = useAtom(schedulerTypeState);

    return useMemo(
        () => ({
            schedulerType,
            setSchedulerType,
        }),
        [schedulerType, setSchedulerType]
    );
};
